<template>
  <form class="create-wishlist" name="createWishlist" @submit.prevent="createWishlist">
    <label for="name" class="create-wishlist__label">
      Add new favorite list
    </label>
    <div class="create-wishlist__input-container">
      <input
        class="create-wishlist__input"
        type="text"
        id="name"
        placeholder="New list name"
        required
        v-model="newListName" />
      <button type="submit" class="create-wishlist__button">
        Add
      </button>
    </div>
    <parts-inline-notification
      v-if="messageText"
      class="create-wishlist__notification"
      :message-text="messageText"
      :message-type="messageType"
      disable-scroll />
  </form>
</template>

<script setup lang="ts">
import { useProductStore } from "~/stores/product";
import { ref } from "#imports";

const emits = defineEmits(['wishlist-created']);

const props = defineProps<{
  productId?: number|string,
}>();

const productStore = useProductStore();

const messageText = ref();
const messageType = ref();
const newListName = ref('');

async function createWishlist () {
  productStore.createWishlist(newListName.value, props.productId)
    .then(() => {
      messageText.value = `"${newListName.value}" created and product was added.`;
      messageType.value = 'success';
      newListName.value = '';

      setTimeout(() => {
        emits('wishlist-created');
      }, 5000);
    }).catch((e) => {
      messageText.value = e.toString();
      messageType.value = 'error';
    });
}
</script>

<style lang="scss">
@use "~/common/scss/form";

.create-wishlist {
  @include form.baseForm('__');

  align-items: stretch;
  display: flex;
  flex-direction: column;
  grid-template: "label input button" auto "notification notification notification" auto / auto 1fr auto;

  &__label {
    align-items: center;
    display: inline-flex;
  }

  &__input-container {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }

  &__input {
    @include form.userInput();

    flex: 1 0 60%;
    width: 100%;
  }

  &__button {
    flex: 1 1 auto;
    max-width: 5rem;
  }

  &__notification {
    grid-area: notification;
  }
}
</style>
